import { render } from "./DataTableView.vue?vue&type=template&id=62981ace&scoped=true"
import script from "./DataTableView.vue?vue&type=script&lang=js"
export * from "./DataTableView.vue?vue&type=script&lang=js"

import "./DataTableView.vue?vue&type=style&index=0&id=62981ace&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62981ace"]])

export default __exports__